import React from 'react'
import { Box, Button, Link, Text } from '@mrshmllw/smores-react'

import { PageWrapper } from '../../components/PageWrapper'

export const OuterError = () => {
  return (
    <PageWrapper>
      <Box flex direction="column" alignItems="center" mt={{ custom: 130 }}>
        <Text tag="h2" typo="heading-large" mb="16px">
          Oops, something broke
        </Text>

        <Box maxWidth="600px" mb="48px">
          <Text align="center">
            Looks like we&apos;ve hit a technical glitch, how embarrassing! Click the refresh button
            to reload the page. If that doesn&apos;t fix it, please contact us by visiting{' '}
            <Link href="https://www.marshmallow.com">https://www.marshmallow.com</Link>.
          </Text>
        </Box>

        <Button primary icon="renewal-line" handleClick={() => window.location.reload()}>
          Try refresh
        </Button>
      </Box>
    </PageWrapper>
  )
}
